import React, { useState } from "react";
import ModuleDefault from "components/module/ModuleDefault"
import { ImpersonateDialog } from "./components/ImpersonateDialog";

export const Dashboard = () => {
    const [show, setShow] = useState(false);
    return (
        <>
            <ModuleDefault
                module={module}
                onClick={() => setShow(true)}
            />
            {
                show &&
                <ImpersonateDialog onClose={() => setShow(false)} />
            }
        </>
    )
}
